// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b7a002fe","239":"06ffec45","453":"a47c187d","455":"b842d2b6"}[chunkId] + ".chunk.js";
};